import React, { useEffect, useState } from 'react';

// custom components
import JobCard from '../job-card';

// redux
import { useSelector } from 'react-redux';
import { selectHasTaskId, selectRampFlightIds } from '_redux/slices/timeline/timeline-bookings';
import { selectThirtyMinLayout } from "_redux/slices/timeline/timeline-control";
import { selectSelectedTask, selectSelectedTasksList, selectSelectedMultiplePAXTask } from "_redux/slices/timeline/selected-task";
import { selectUsedTheme } from '_redux/slices/timeline/theme';

const RampTask = (props) => {

    const [id, setId] = useState(null);
    const rampFlightIds = useSelector(selectRampFlightIds);

    // check if ramp task has been placed before rendering
    const placedOnTimeline = useSelector(selectHasTaskId(id));
    // const allBookings = useSelector(selectAllBookingsByFlight(props?.flightKey));
    const thirtyMinLayout = useSelector(selectThirtyMinLayout);


    // OPTIMIZED: Get these once and pass to JobCard to reduce Redux subscriptions
    const selectedTask = useSelector(selectSelectedTask);
    const selectedTasksList = useSelector(selectSelectedTasksList);
    const usedTheme = useSelector(selectUsedTheme);
    const selectedMultiplePAXTask = useSelector(selectSelectedMultiplePAXTask);

    useEffect(() => {
        setId(props?.flightKey + '-ramp-task');
    }, [props])
    if (placedOnTimeline) return null;
    if (!Array.isFullArray(props?.flightData?.rampPassengers)) return null;

    if (rampFlightIds.includes(props?.flightData?.flightId)) return null;
    return (
        <JobCard
            showFullCard={true}
            key={id}
            job={
                {
                    _id: id,
                    jobType: 'ramp-task',
                    description: 'Ramp Task for flight ' + props.flightKey,
                    flightKey: props.flightKey,
                    flightNumber: props.flightNumber,
                    flightData: props.flightData,
                    status: 'pending',
                    createdAt: new Date().toISOString(),
                    passengers: Array.isFullArray(props?.flightData?.rampPassengers) ? props?.flightData?.rampPassengers : [],
                    combinedRampBooking: true,
                }
            }
            timelineJobs={true}
            flightData={props.flightData}
            isBoardingFlight={false}
            isRampTask={true}
            thirtyMinLayout={thirtyMinLayout}
            selectedTask={selectedTask}
            selectedTasksList={selectedTasksList}
            usedTheme={usedTheme}
            selectedMultiplePAXTask={selectedMultiplePAXTask}
        />
    );
};

export default RampTask;
